import React from "react";
import { Package } from "lucide-react";
import { Offer } from "types/Stripe.type";
import { Steps } from "components/steps/steps";
import LogoMobile from "assets/images/logo-checkdpe-mobile.png";
import { ReactComponent as IconArrow } from "assets/images/arrow.svg";
import {  CheckOutlined } from '@ant-design/icons'

import "styles/stripe.scss";

const OrderSummary: React.FC<Offer> = ({
  name,
  price,
  description,
  refAdeme,
  address,
}) => {
  const descriptionItems = description
    .split("\n")
    .map((item) => item.trim())
    .filter(Boolean);
  return (
    <>
      <Steps stepNames={["offer", "payment"]} />
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex items-center mb-4">
            <Package className="w-6 h-6 package-icon mr-2" />
            <h2 className="text-xl font-bold text-gray-800">
              Résumé de la commande
            </h2>
          </div>

          <div className="space-y-3">
            <div className="flex justify-between text-gray-700">
              <span>{name}</span>
              <span>{price.toFixed(2)} €</span>
            </div>
            <span className="whitespace-pre-line">Référence ADEME : </span>
            {refAdeme}
            <br />
            <span className="whitespace-pre-line">Adresse : </span>
            {address}

            {descriptionItems.length > 0 && (
              <ul className="mt-2 space-y-2 text-gray-700 text-left">
                {descriptionItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-x-2">
                    <CheckOutlined className="w-4 h-4 fill-[#15585a] relative top-1 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            )}

            <div className="border-t pt-3 mt-3">
              <div className="flex justify-between font-bold text-lg">
                <span>Total</span>
                <span>{price.toFixed(2)} €</span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 xl:hidden mb-6">
          <img src={LogoMobile} alt="logo" className="w-[80px] mx-auto mb-2" />
          <h5 className="text-[#3c3c3c] font-bold text-center">
            Les prochaines étapes
          </h5>

          <ul className="list-disc ml-4 mt-4 text-base text-[#3c3c3c] text-left">
            <li className="flex items-start gap-x-1">
              <IconArrow className="w-5 h-5 fill-[#15585a] relative top-1 flex-shrink-0" />
              <span>
                Saisie des <b>informations</b> nécessaires à la
                finalisation de votre commande (mail, moyen de paiement)
              </span>
            </li>
            <li className="flex items-start gap-x-1">
              <IconArrow className="w-5 h-5 fill-[#15585a] relative top-1 flex-shrink-0" />
              <span>Validation du paiement auprès de votre banque</span>
            </li>
            <li className="flex items-start gap-x-1">
              <IconArrow className="w-5 h-5 fill-[#15585a] relative top-1 flex-shrink-0" />
              <span>
                Activation de votre compte (un code vous sera envoyé à votre
                mail)
              </span>
            </li>
            <li className="flex items-start gap-x-1">
              <IconArrow className="w-5 h-5 fill-[#15585a] relative top-1 flex-shrink-0" />
              <span>
                Accès à votre <b>tableau de bord du DPE</b> avec le <b>score de fiabilité</b> et les anomalies
              </span>
            </li>
            <li className="flex items-start gap-x-1">
              <IconArrow className="w-5 h-5 fill-[#15585a] relative top-1 flex-shrink-0" />
              <span>
                Un <b>rapport de fiabilité au format pdf</b>, vous sera envoyé
                dans les 24h
              </span>
            </li>
          </ul>

          <p className="text-center text-lg mt-5">
            Une question ? Un problème ?
          </p>
          <p className="text-center text-lg mt-2">
            Contactez-nous :{" "}
            <a
              href="mailto:support@checkdpe.fr"
              className="!text-[#3c3c3c] font-normal"
            >
              support@checkdpe.fr
            </a>
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 xl:hidden">
          <img
            src="https://checkdpe.fr/wp-content/uploads/2025/09/rapport-checkDPE.webp"
            alt="exemple de dashboard"
          />
        </div>
      </div>
    </>
  );
};

export default OrderSummary;
